import AbstractLogicalOperatorRuleSpecification from './AbstractLogicalOperatorRuleSpecification'

export default class AndRuleSpecification extends AbstractLogicalOperatorRuleSpecification {
  _executeCheckIsSatisfiedBy (entity) {
    for (const rule of this.rules) {
      if (!rule.isSatisfiedBy(entity)) {
        this.addReasonsNotSatisfiedBy(rule.getReasonsNotSatisfied())

        return false
      }
    }

    return true
  }
}
